import React from "react";
import { toast } from "react-toastify";
import { css } from "glamor";
import { Icons } from "../components/UI/Icon/Icon";

import style from "./helper.scss";

export const addMonth = function (date, monthsToAdd) {
  const d = date;
  d.setMonth(d.getMonth() + monthsToAdd);
  return d;
};

export const addDay = function (date, daysToAdd) {
  const d = date;
  d.setDate(d.getDate() + daysToAdd);
  return d;
};

export const toPascalCase = (word) => {
  return (word = word[0].toUpperCase() + word.substring(1).toLowerCase());
};

export const toPascalCaseString = (word) => {
  const division = word.split(" ");
  let answer = "";
  division.map((item) => {
    answer += toPascalCase(item) + " ";
  });
  return answer;
};

export const espLang = {
  time: {
    month: [
      "Enero",
      "Febrero",
      "Marzo",
      "Abril",
      "Mayo",
      "Junio",
      "Julio",
      "Agosto",
      "Septiembre",
      "Dctubre",
      "Noviembre",
      "Diciembre",
    ],
    monthAbbr: ["Ene", "Feb", "Mar", "Abr", "May", "Jun", "Jul", "Ago", "Sep", "Oct", "Nov", "Dic"],
    dayOfWeek: ["domingo", "lunes", "martes", "miércoles", "jueves", "viernes", "sábado"],
    dayOfWeekAbbr: ["dom", "lun", "mar", "mie", "jue", "vie", "sáb"],
  },
  legend: {
    selector: {
      all: "Todas",
      inverse: "Inversa",
    },
  },
  toolbox: {
    brush: {
      title: {
        rect: "Selección de cuadro",
        polygon: "Selección de lazo",
        lineX: "Seleccionar horizontalmente",
        lineY: "Seleccionar verticalmente",
        keep: "Mantener selección",
        clear: "Despejar selecciones",
      },
    },
    dataView: {
      title: "Ver datos",
      lang: ["Ver datos", "Cerrar", "Actualizar"],
    },
    dataZoom: {
      title: {
        zoom: "Zoom",
        back: "Restablecer zoom",
      },
    },
    magicType: {
      title: {
        line: "Cambiar a gráfico de líneas",
        bar: "Cambiar a gráfico de barras",
        stack: "Pila",
        tiled: "Teja",
      },
    },
    restore: {
      title: "Restaurar",
    },
    saveAsImage: {
      title: "Guardar como imagen",
      lang: ["Clic derecho para guardar imagen"],
    },
  },
};

export const showToast = (text, err = false) => {
  if (err) {
    return customToast.error(text);
  }
  return customToast.info(text);
};

export const customToast = {
  info(msg, options = {}) {
    return toast(
      <div className={style.toast}>
        <Icons.InformationIcon size="md" />
        <span className={style.msg}>{msg}</span>
        <Icons.Close size="sm" className={style.icon} />
      </div>,
      {
        ...options,
        className: css({
          background: "#FFFFFF",
          borderRadius: 15.63,
          padding: 20.85,
          border: "solid #004799 1px",
        }),
        hideProgressBar: true,
        closeButton: false,
      }
    );
  },
  error(msg, options = {}) {
    return toast(
      <div className={style.toast}>
        <Icons.ErrorIcon size="md" />
        <span className={style.msg}>{msg}</span>
        <Icons.Close size="sm" className={style.icon} />
      </div>,
      {
        ...options,
        className: css({
          background: "#FFFFFF",
          borderRadius: 15.63,
          padding: 20.85,
          color: "#ffffff",
          border: "solid #99173C 1px",
        }),
        hideProgressBar: true,
        closeButton: false,
      }
    );
  },
  success(msg, options = {}) {
    return toast(
      <div className={style.toast}>
        <Icons.SuccessIcon size="md" />
        <span className={style.msg}>{msg}</span>
        <Icons.Close size="sm" className={style.icon} />
      </div>,
      {
        ...options,
        className: css({
          background: "#FFFFFF",
          borderRadius: 15.63,
          padding: 20.85,
          color: "#ffffff",
          border: "solid #146542 1px",
        }),
        hideProgressBar: true,
        closeButton: false,
      }
    );
  },
  warning(msg, options = {}) {
    return toast(
      <div className={style.toast}>
        <Icons.WarningIcon size="md" />
        <span className={style.msg}>{msg}</span>
        <Icons.Close size="sm" className={style.icon} />
      </div>,
      {
        ...options,
        className: css({
          background: "#FFFFFF",
          borderRadius: 15.63,
          padding: 20.85,
          color: "#ffffff",
          border: "solid #664400 1px",
        }),
        hideProgressBar: true,
        closeButton: false,
      }
    );
  },
};

export const FEATURE = Object.freeze({
  SELL_REQUEST: "SELL_REQUEST",
  AUTHORIZE: "AUTHORIZE",
  INVEST: "INVEST",
});

/**
 * Comprueba si la cuenta seleccionada puede ejecutar la acción indicada.
 *
 * @param {string} action – Una de las propedades de FEATURE (por ej. 'SELL_REQUEST').
 * @param {{ type: string, id: number }} selectedAccount – Objeto con la cuenta actual.
 * @returns {boolean}
 */
export const isActionAllowed = (action, selectedAccount) => {
  try {
    const { FeatureGroup } = window.___APP_CONFIG___.FEATURE_FLAGS;
    const cfg = FeatureGroup[0].Features.find((feature) => feature.FeatureName === action);
    if (!cfg) {
      // La acción no está definida en la configuración, debe permitir
      return true;
    }

    const accountType = selectedAccount.isPhysical ? "Physical" : "Juridical";
    const matchesType = accountType == cfg.AccountType;
    let matchesId = false;
    cfg.AccountId &&
      cfg.AccountId.forEach((account) => {
        if (account == selectedAccount.id) {
          matchesId = true;
        }
      });

    return matchesType || matchesId;
  } catch (error) {
    console.error(error);
    return true;
  }
};
